module.exports = __webpack_public_path__ + "static/img/2.8f59e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/2.png
// module id = 0U1K
// module chunks = 25